import {
  AdvicePage,
  getAdvicePageServerSideProps,
} from '@exploration/pages-advice';

export const getServerSideProps = getAdvicePageServerSideProps;

export default AdvicePage;
